import { useEffect } from 'react'
import RocketSvg from '~/assets/usecase-fork/rocket.svg?react'

interface CalendarBookingProps {
  onComplete: () => void
}

export function CalendarBooking({ onComplete }: CalendarBookingProps) {
  const hubspotBookingUrl = 'https://meetings.hubspot.com/paul-landry1/build-for-me-corporate-website-choice'

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== 'https://meetings.hubspot.com') return

      if (event.data?.meetingBookSucceeded === true) {
        setTimeout(() => {
          onComplete()
        }, 5000)
      }
    }

    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [onComplete])

  return (
    <div className="fixed inset-0 z-[100] flex flex-col bg-[#f5f8fa] md:flex-row md:gap-6 md:p-6">
      {/* Left Side - Hidden on mobile */}
      <div className="relative hidden flex-col justify-end rounded-[20px] bg-[#e6e1d8] px-6 py-8 md:flex md:w-[40%] md:rounded-[10px] md:px-[72px] md:pb-12">
        <div className="pointer-events-none absolute right-4 top-8 md:right-[16px] md:top-[43px]">
          <RocketSvg className="h-[200px] w-[175px] opacity-30 md:h-[406px] md:w-[351px] md:opacity-100" />
        </div>

        <div className="relative z-10 flex w-full max-w-[593px] flex-col gap-6 md:gap-12">
          <h1
            className="max-w-[70%] text-2xl font-normal text-black md:text-[72px]"
            style={{ fontFamily: 'Times New Roman, serif', lineHeight: 1.1 }}
          >
            Book a meeting
          </h1>

          <button
            onClick={onComplete}
            className="w-fit text-xs text-black underline transition-opacity hover:opacity-70 md:text-base"
          >
            Skip
          </button>
        </div>
      </div>

      {/* Mobile Header */}
      <div className="flex flex-col items-center gap-4 p-4 md:hidden">
        <h1 className="text-center text-2xl font-normal text-black" style={{ fontFamily: 'Times New Roman, serif' }}>
          Book a meeting
        </h1>
        <button onClick={onComplete} className="text-xs text-black underline transition-opacity hover:opacity-70">
          Skip
        </button>
      </div>

      {/* Calendar */}
      <div className="relative flex flex-1 items-center justify-center overflow-hidden p-4 md:rounded-[10px] md:p-0">
        <div className="h-full w-full" style={{ transform: 'scale(0.8)' }}>
          <iframe
            src={hubspotBookingUrl}
            className="border-0"
            title="Book a meeting with Botpress"
            style={{ height: '125%', width: '125%', marginLeft: '-12.5%', marginTop: '-12.5%' }}
          />
        </div>
      </div>
    </div>
  )
}
